import { render, staticRenderFns } from "./SharedPageInvalidTokenError.vue?vue&type=template&id=c2921770"
import script from "./SharedPageInvalidTokenError.js?vue&type=script&lang=js&external"
export * from "./SharedPageInvalidTokenError.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports